// Smooth scroll to fragment ID
(function ( $ ) {
	$( document ).ready( function () {

		var target = $( window.location.hash );

		window.onload = function () {
			if ( target.length > 0 ) {
				var scrollTop = target.offset().top;

				// Get nav height and subtract to top offset of target element
				var navBar = $( '.navbar' );
				if ( navBar.length > 0 ) {
					scrollTop -= parseInt( navBar.css( 'height' ) );
				}

				// Get wpadminbar height and subtract to top offset of target element
				var wpAdminBar = $( '#wpadminbar' );
				if ( wpAdminBar.length > 0 ) {
					scrollTop -= parseInt( wpAdminBar.css( 'height' ) );
				}

				// Call stop() to avoid shaking behavior in Chrome
				$( 'html, body' ).stop( true ).animate( {
					scrollTop: scrollTop
				}, 1000 );
			}
		};
	} );
})( jQuery );